import React from "react";
import {Box, Typography} from "@mui/material";
import {a, panelSx} from "../auth/components/authStyles";
import {TERMS_CONTENT} from "./termsContent";
import {PRIVACY_CONTENT} from "./privacyContent";

const LegalPage = ({content}) => (
  <Box sx={{minHeight: "100vh", bgcolor: a.bg, py: {xs: 2, md: 6}, px: 2}}>
    <Box sx={{...panelSx, maxWidth: 800, mx: "auto", p: {xs: 3, md: 6}}}>
      <Typography sx={{fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: a.accent, mb: 1}}>
        OpenBrain
      </Typography>
      <Typography component="h1" sx={{fontSize: {xs: 24, md: 30}, fontWeight: 600, color: a.ink, mb: 1}}>
        {content.title}
      </Typography>
      <Box
        dangerouslySetInnerHTML={{__html: content.html}}
        sx={{
          color: a.text,
          fontSize: 14.5,
          lineHeight: 1.75,
          "& h1": {fontSize: 18, fontWeight: 600, color: a.ink, mt: 4, mb: 1},
          "& p": {m: "0 0 12px"},
          "& em": {color: a.muted},
          "& a": {color: a.accentText},
          "& ul, & ol": {pl: 3, mb: 1.5},
        }}
      />
    </Box>
  </Box>
);

export const TermsPage = () => <LegalPage content={TERMS_CONTENT}/>;
export const PrivacyPage = () => <LegalPage content={PRIVACY_CONTENT}/>;
